import moment from "moment";
import React from "react";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { FormControl } from "../../../../facturotopia";

const PersonalizarFechaEmision = (props) => {
  const { data } = props;

  const handleOnChange = (value) => {
    props.onChange(value);
  }

  const Help = () => {
    return (
      <div>
        Emite tu comprobante después de la fecha { moment().subtract(71, 'hours').format('DD/MM/YYYY HH:mm') }
      </div>)
  };

  return (
    <div className="mt-3">
      <Form autoComplete="off">
        <FormControl type="datetime-picker"
          id="CfdiFecha"
          label="Fecha de Emisión de tu comprobante:"
          name="CfdiFecha"
          help={ Help() }
          clearIcon={ <FontAwesomeIcon icon={ ['fas', 'times'] } /> }
          maxDate={ new Date() }
          value={ data.CfdiFecha }
          onChange={ handleOnChange }
        />
      </Form>
    </div>
  );
}

export default PersonalizarFechaEmision;
